export const CallStatusList = [
  { id: 1, value: "Hot" },
  { id: 2, value: "Medium" },
  { id: 3, value: "Cold" },
];

export const CallTypeList = [
  { id: 1, value: "Phone" },
  { id: 2, value: "Physical" },
  { id: 3, value: "Other" },
];

export const LeadList = [
  { id: 1, value: "Self" },
  { id: 2, value: "Lead" },
];

export const ContinueLeadList = [
  { id: 1, value: "Self" },
  { id: 2, value: "Lead" },
  { id: 3, value: "Continue" },
]

export const DAR_VerticalList = [
  { id: 1, value: "ASG" },
  { id: 2, value: "ISG" },
  { id: 3, value: "PSG" },
  { id: 6, value: "ESG" }
];

export const SalesStatus = [
  { id: 1, value: "Lost" },
  { id: 2, value: "Closed" },
  { id: 3, value: "Open" },
];

export const LostReasonList = [
  { id: 1, value: "Insufficient Fund" },
  { id: 2, value: "Higher price" },
  { id: 3, value: "Technically not qualified" },
  { id: 4, value: "Competitor" },
  { id: 5, value: "Others" },
];

export const OpportunityStatusList = [
  { id: 1, value: "Introduction Call (10%)", percent: 10, totalStagePercent: 10, tooltipText: "Process completion percent" },
  { id: 2, value: "Demo Done (10%)", percent: 10, totalStagePercent: 20, tooltipText: "Process completion percent" },
  { id: 3, value: "Quotation Submitted (20%)", percent: 20, totalStagePercent: 40, tooltipText: "Process completion percent" },
  { id: 4, value: "Fund Available (20%)", percent: 20, totalStagePercent: 60, tooltipText: "Process completion percent" },
  { id: 5, value: "Final Negotiation (20%)", percent: 20, totalStagePercent: 80, tooltipText: "Process completion percent" },
  { id: 6, value: "Order Received (15%)", percent: 15, totalStagePercent: 95, tooltipText: "Process completion percent" },
  { id: 7, value: "Payment Received (5%)", percent: 5, totalStagePercent: 100, tooltipText: "Process completion percent" },
  { id: 8, value: "Installation/Training", percent: null, totalStagePercent: null, tooltipText: "Process completion percent" },
  { id: 9, value: "Payment Followup", percent: null, totalStagePercent: null, tooltipText: "Process completion percent" },
  { id: 10, value: "Technical Support / AMC", percent: null, totalStagePercent: null, tooltipText: "Process completion percent" },
  // { id: 11, value: "InOffice" },
];

export const edaOpportunityStatusList = [
  { id: 1, value: "Customer Interested (10%)", percent: 10, totalStagePercent: 10, tooltipText: "MEDDIC percentage for Pipeline" },
  { id: 2, value: "Fund Available (20%)", percent: 20, totalStagePercent: 30, tooltipText: "MEDDIC percentage for Qualified Pipeline" },
  { id: 3, value: "Quotation Submitted (10%)", percent: 10, totalStagePercent: 40, tooltipText: "MEDDIC percentage for Qualified Pipeline" },
  { id: 4, value: "Demo Done (10%)", percent: 10, totalStagePercent: 50, tooltipText: "MEDDIC percentage for Upside" },
  { id: 5, value: "Purchase Initiated (10%)", percent: 10, totalStagePercent: 60, tooltipText: "MEDDIC percentage for Strong Upside" },
  { id: 6, value: "Closure Date Predict (20%)", percent: 20, totalStagePercent: 80, tooltipText: "MEDDIC percentage for Strong Upside" },
  { id: 7, value: "Final Negotiation (10%)", percent: 10, totalStagePercent: 90, tooltipText: "MEDDIC percentage for Commit" },
  { id: 8, value: "Order Received (5%)", percent: 5, totalStagePercent: 95, tooltipText: "MEDDIC percentage for Finished" },
  { id: 9, value: "Payment Received (5%)", percent: 5, totalStagePercent: 100, tooltipText: "MEDDIC percentage for Finished" }
];

export const edaAppEngineerOpportunityStatusList = [
  { id: 1, value: "Customer Interested (10%)", percent: 10, totalStagePercent: 10 },
  { id: 2, value: "Fund Available (20%)", percent: 20, totalStagePercent: 30 },
  { id: 3, value: "Quotation Submitted (10%)", percent: 10, totalStagePercent: 40 },
  { id: 4, value: "Demo Done (10%)", percent: 10, totalStagePercent: 50 },
  { id: 8, value: "Order Received (5%)", percent: 5, totalStagePercent: 55 },
  { id: 5, value: "Installation Completed (15%)", percent: 15, totalStagePercent: 70 },
  { id: 6, value: "Training Completed (20%)", percent: 20, totalStagePercent: 90 },
  { id: 7, value: "Customer Signed Inst. Training report received (5%)", percent: 5, totalStagePercent: 95 },
  { id: 9, value: "Payment Received (5%)", percent: 5, totalStagePercent: 100 }
]

export const FundAvailableOptionsList = [
  { id: "Yes", value: "Yes" },
  { id: "No", value: "No" },
];

export const plainOptions = [0, 5, 18, 28];

export const productColumns = [
  {
    title: 'Product',
    dataIndex: 'productName',
    key: 'productName',
    width: '16%',
  },
  {
    title: 'Price',
    dataIndex: 'techlabPrice',
    key: 'techlabPrice',
    width: '8%',
  },
  {
    title: 'Quoted Price',
    dataIndex: 'quotedPrice',
    key: 'quotedPrice',
    width: '12%',
  },
  {
    title: 'Product Value',
    dataIndex: 'productValue',
    key: 'productValue',
    width: '12%',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: '52%',
  }
]

export const DarProgressList = [
  {
    id: 1, value: 'Introduction Call (10%)'
  },
  {
    id: 2, value: 'Demo Done (20%)'
  },
  {
    id: 3, value: 'Quotation Submitted (40%)'
  },
  {
    id: 4, value: 'Fund Available (60%)'
  },
  {
    id: 5, value: 'Final Negotiation (80%)'
  },
  {
    id: 6, value: 'Order Received (95%)'
  },
  {
    id: 7, value: 'Payment Received (100%)'
  }
];

export const grades = [
  {
    text: "M1",
    value: "33",
  },
  {
    text: "M2",
    value: "34"
  },
  {
    text: "M3",
    value: "35"
  },
  {
    text: "Design",
    value: "36"
  },
  {
    text: "G1",
    value: "1"
  },
  {
    text: "G2",
    value: "2"
  },
  {
    text: "G3",
    value: "3"
  },
  {
    text: "G4",
    value: "4"
  },
  {
    text: "G5",
    value: "10"
  },
  {
    text: "G6",
    value: "11"
  },
  {
    text: "G7",
    value: "12"
  },
  {
    text: "TE1",
    value: "37"
  },
  {
    text: "TE2",
    value: "38"
  },
  {
    text: "TE3",
    value: "39"
  },
  {
    text: "TE4",
    value: "40"
  },
  {
    text: "TE5",
    value: "41"
  },
  {
    text: "TE6",
    value: "42"
  },
  {
    text: "TE7",
    value: "43"
  },
  {
    text: "TM1",
    value: "44"
  },
  {
    text: "TM2",
    value: "45"
  },
  {
    text: "TM3",
    value: "46"
  },
  {
    text: "TM4",
    value: "47"
  },
  {
    text: "TM5",
    value: "48"
  },
  {
    text: "TM6",
    value: "49"
  },
  {
    text: "TM7",
    value: "50"
  }
];

export const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];

export class CustomError extends Error {
  constructor({ code, text, message = "Bad Request" }) {
    super(text);
    this.code = code;
    this.text = text;
    this.message = message;
  }
}

export const appTableStyles = {
  components: {
    Table: {
      borderColor: "lightgrey",
      headerBg: "#da251c",
      headerColor: "white",
      cellFontSizeSM: 6,
      rowHoverBg: "#d1d1d1",
      cellPaddingInlineSM: 8,
      cellPaddingBlock: 12,
      fontSize: "13px",
      headerBorderRadius: '5px'
    },
  },
}
export const greenTableStyles = {
  components: {
    Table: {
      borderColor: "lightgrey",
      headerBg: "green",
      headerColor: "white",
      cellFontSizeSM: 6,
      rowHoverBg: "#d1d1d1",
      cellPaddingInlineSM: 8,
      cellPaddingBlock: 12,
      fontSize: "13px",
      headerBorderRadius: '0px'
    },
  },
}

export const monthList = [
  // {
  //   id: 1,
  //   full: 'January',
  //   short: 'Jan',
  //   number: 1,
  //   noOfDays: 31
  // },
  {
    id: 1,
    full: 'January',
    short: 'Jan',
    number: 1,
    noOfDays: 31
  },
  {
    id: 2,
    full: 'February',
    short: 'Feb',
    number: 2,
    noOfDays: 28
  },
  {
    id: 3,
    full: 'March',
    short: 'Mar',
    number: 3,
    noOfDays: 31
  },
  {
    id: 4,
    full: 'April',
    short: 'Apr',
    number: 4,
    noOfDays: 30
  },
  {
    id: 5,
    full: 'May',
    short: 'May',
    number: 5,
    noOfDays: 31
  },
  {
    id: 6,
    full: 'June',
    short: 'Jun',
    number: 6,
    noOfDays: 30
  },
  {
    id: 7,
    full: 'July',
    short: 'Jul',
    number: 7,
    noOfDays: 31
  },
  {
    id: 8,
    full: 'August',
    short: 'Aug',
    number: 8,
    noOfDays: 31
  },
  {
    id: 9,
    full: 'September',
    short: 'Sep',
    number: 9,
    noOfDays: 30
  },
  {
    id: 10,
    full: 'October',
    short: 'Oct',
    number: 10,
    noOfDays: 31
  },
  {
    id: 11,
    full: 'November',
    short: 'Nov',
    number: 11,
    noOfDays: 30
  },
  {
    id: 12,
    full: 'December',
    short: 'Dec',
    number: 12,
    noOfDays: 31
  }
];